import { render, staticRenderFns } from "./AdAb.vue?vue&type=template&id=70a2698a&scoped=true"
import script from "./AdAb.vue?vue&type=script&lang=js"
export * from "./AdAb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a2698a",
  null
  
)

export default component.exports